import { navigateToUrl } from 'src/services/navigation';

export function close(context) {
  const { current } = this.$router.history;

  context.commit('setIndex', null);

  if (current.name === 'map-previews') {
    // Handle user closing gallery
    navigateToUrl({
      name: 'map-selected',
      params: {
        key: current.params.key,
      },
    });
  }
}

export function openItems(context, { items = [], index = 0 }) {
  context.commit('setItems', items);
  context.commit('setIndex', index);
}
